module.exports = __webpack_public_path__ + "img/lv11.1a658bac.png";